"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewShift = exports.useShiftActivityDesign = exports.SHIFT_HOURS = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Popover = __importStar(require("@radix-ui/react-popover"));
const enums_1 = require("@bemlo/enums");
const schedule_1 = require("@bemlo/schedule");
const useCellTheme_1 = require("./useCellTheme");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const TooltipIcon_1 = require("../../../../molecules/TooltipIcon");
const translate_1 = require("../../../../translate");
const ShiftCrossSection_1 = require("../../ShiftCrossSection");
const useSchedule_1 = require("../useSchedule");
const ShiftChannelIndicators_1 = require("./ShiftChannelIndicators");
const WARNING_CSS = {
    position: 'absolute',
    left: -17,
    // Center vertically
    top: '50%',
    transform: 'translateY(-50%)',
};
const RelativeWrapper = (0, styled_1.default)(elements_1.Div)(({ position }) => ({
    position: 'relative',
    width: '100%',
    height: position === 'stretch' ? '100%' : 'auto',
    margin: position === 'center' ? `auto 0px` : undefined,
}));
const PopoverContentWrapper = (0, styled_1.default)(Popover.Content)({
    zIndex: constants_1.theme.zIndex.popover,
});
exports.SHIFT_HOURS = {
    [enums_1.ShiftHours.DAY]: {
        backgroundColor: constants_1.Color.LIGHTEST_BLUE,
        color: constants_1.Color.CHARCOAL,
        iconColor: constants_1.Color.BLUE,
        icon: 'SunIcon',
        shiftHours: enums_1.ShiftHours.DAY,
    },
    [enums_1.ShiftHours.EVENING]: {
        backgroundColor: '#FFF7F7',
        color: constants_1.Color.CHARCOAL,
        iconColor: constants_1.Color.RED,
        icon: 'EveningIcon',
        shiftHours: enums_1.ShiftHours.EVENING,
    },
    [enums_1.ShiftHours.LONG]: {
        backgroundColor: '#FFF7F7',
        color: constants_1.Color.CHARCOAL,
        iconColor: constants_1.Color.PINK,
        icon: 'DayEveningIcon',
        shiftHours: enums_1.ShiftHours.LONG,
    },
    [enums_1.ShiftHours.NIGHT]: {
        backgroundColor: '#F8EFFF',
        color: constants_1.Color.CHARCOAL,
        iconColor: constants_1.Color.VIOLET,
        icon: 'NightIcon',
        shiftHours: enums_1.ShiftHours.NIGHT,
    },
};
const useShiftActivityDesign = (activity, shiftHoursDesign, shift) => {
    switch (activity) {
        case enums_1.ShiftActivity.FLEX:
            return {
                backgroundColor: elements_1.SHIFT_ACTIVITY_COLORS.FLEX.background,
                color: constants_1.Color.CHARCOAL,
                iconColor: constants_1.Color.CHARCOAL,
                icon: elements_1.SHIFT_ACTIVITY_COLORS.FLEX.icon,
                shiftHours: shiftHoursDesign.shiftHours,
            };
        case enums_1.ShiftActivity.TEAM_MEETING:
            return {
                backgroundColor: elements_1.SHIFT_ACTIVITY_COLORS.TEAM_MEETING.background,
                color: constants_1.Color.CHARCOAL,
                iconColor: constants_1.Color.CHARCOAL,
                icon: elements_1.SHIFT_ACTIVITY_COLORS.TEAM_MEETING.icon,
                shiftHours: shiftHoursDesign.shiftHours,
            };
        case enums_1.ShiftActivity.TRAINING:
            return {
                backgroundColor: elements_1.SHIFT_ACTIVITY_COLORS.TRAINING.background,
                color: constants_1.Color.WHITE,
                iconColor: constants_1.Color.WHITE,
                icon: elements_1.SHIFT_ACTIVITY_COLORS.TRAINING.icon,
                shiftHours: shiftHoursDesign.shiftHours,
            };
        case enums_1.ShiftActivity.INTRODUCTION:
            return {
                backgroundColor: elements_1.SHIFT_ACTIVITY_COLORS.INTRODUCTION.background,
                color: constants_1.Color.WHITE,
                iconColor: constants_1.Color.WHITE,
                icon: elements_1.SHIFT_ACTIVITY_COLORS.INTRODUCTION.icon,
                shiftHours: shiftHoursDesign.shiftHours,
            };
        case enums_1.ShiftActivity.OTHER:
            return {
                backgroundColor: elements_1.SHIFT_ACTIVITY_COLORS.OTHER.background,
                color: constants_1.Color.WHITE,
                iconColor: constants_1.Color.WHITE,
                icon: elements_1.SHIFT_ACTIVITY_COLORS.OTHER.icon,
                label: shift.comment,
                shiftHours: shiftHoursDesign.shiftHours,
            };
        case enums_1.ShiftActivity.WORK:
            return shiftHoursDesign;
        default:
            return shiftHoursDesign;
    }
};
exports.useShiftActivityDesign = useShiftActivityDesign;
const useShiftDesign = (status, shift) => {
    const t = (0, translate_1.useTranslations)();
    const shiftHours = (0, schedule_1.getShiftHours)(shift);
    const shiftHoursDesign = exports.SHIFT_HOURS[shiftHours];
    const shiftActivityDesign = (0, exports.useShiftActivityDesign)(shift.activity, shiftHoursDesign, shift);
    const isWork = shift.activity === enums_1.ShiftActivity.WORK;
    const isFlex = shift.activity === enums_1.ShiftActivity.FLEX;
    const cellDesign = (0, useCellTheme_1.useCellTheme)();
    if (status === 'BOOKED') {
        return shiftActivityDesign;
    }
    if (status === 'DRAFT') {
        return {
            ...shiftActivityDesign,
            iconColor: isWork
                ? shiftActivityDesign.iconColor
                : isFlex
                    ? constants_1.Color.BRIGHT_YELLOW
                    : shiftActivityDesign.backgroundColor,
            backgroundColor: constants_1.Color.BACKGROUND_GREY,
            borderStyle: 'dashed',
            label: t.$shiftActivity(shift.activity),
        };
    }
    if (status === 'CANCELLED') {
        return {
            label: t.shifts.cancelled(),
            backgroundColor: constants_1.Color.WHITE,
            color: constants_1.Color.CHARCOAL,
            iconColor: constants_1.Color.RED,
            icon: 'XIcon',
            shiftHours,
        };
    }
    if (status === 'SUGGESTED') {
        return {
            label: t.shifts.suggested(),
            backgroundColor: constants_1.Color.YELLOW,
            color: constants_1.Color.CHARCOAL,
            iconColor: constants_1.Color.CHARCOAL,
            icon: shiftHoursDesign.icon,
            shiftHours,
        };
    }
    const { background, color, label, iconProps } = cellDesign[status];
    const theme = {
        label,
        backgroundColor: background,
        color,
        iconColor: iconProps.color,
        icon: iconProps.name,
        shiftHours,
    };
    if (status === 'VACANT') {
        return {
            ...theme,
            label: undefined,
            iconColor: shiftHoursDesign.iconColor,
            icon: shiftHoursDesign.icon,
        };
    }
    if (status === 'ACCEPTED') {
        return {
            ...theme,
            icon: shiftHoursDesign.icon,
        };
    }
    if (status === 'PRESET') {
        return {
            ...theme,
            borderWidth: 2,
            iconColor: shiftHoursDesign.iconColor,
            icon: shiftHoursDesign.icon,
        };
    }
    if (status === 'ACTIVE_PRESET') {
        return {
            ...shiftHoursDesign,
            borderColor: shiftHoursDesign.iconColor,
            borderWidth: 2,
            label,
        };
    }
    return theme;
};
const Card = styled_1.default.div(({ backgroundColor, color, borderColor, borderWidth, borderStyle, hasOnCall, hoverable, selected, selectable, isUrgent, isAbsent, isAtOtherUnit, zoom, position, }) => ({
    // Remove all button styles
    unset: 'all',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    textAlign: 'left',
    backgroundColor,
    color,
    borderWidth: borderWidth ?? 1,
    borderStyle: borderStyle ?? 'solid',
    borderColor: borderColor ?? 'rgba(0, 0, 0, 0.2)',
    height: 'min-content',
    ...(position === 'stretch' && { height: '100%', justifyContent: 'center' }),
    ...(position === 'center' && {
        justifyContent: 'center',
        margin: `auto 0px`,
    }),
    width: '100%',
    borderRadius: constants_1.theme.border.radius.normal,
    paddingTop: constants_1.theme.spacing[2],
    paddingBottom: hasOnCall ? undefined : constants_1.theme.spacing[2],
    paddingLeft: 0,
    paddingRight: 0,
    ...(isUrgent && {
        border: `1px solid ${constants_1.Color.RED}`,
        borderLeft: zoom !== 'month' ? `19px solid ${constants_1.Color.RED}` : undefined,
    }),
    ...(isAbsent && {
        border: `1px solid ${constants_1.Color.CHARCOAL}`,
        borderLeft: zoom !== 'month' ? `19px solid ${constants_1.Color.CHARCOAL}` : undefined,
    }),
    ...(isAtOtherUnit && {
        filter: 'grayscale(100%)',
    }),
    ...(selectable && {
        cursor: 'pointer',
    }),
    '.checkbox': {
        display: selected ? 'block' : 'none',
        zIndex: 2,
    },
    '.icon': {
        display: selected ? 'none' : undefined,
    },
    ':hover': {
        ...(hoverable && {
            cursor: 'pointer',
            filter: 'brightness(0.95)',
        }),
        ...(selectable && {
            '.checkbox': {
                display: 'block',
            },
            '.icon': {
                display: 'none',
            },
        }),
    },
}));
const MonthContent = styled_1.default.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
});
const Content = styled_1.default.div({
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `0px ${constants_1.theme.spacing['2.5']}px`,
});
const StyledChannelIndicators = (0, styled_1.default)(ShiftChannelIndicators_1.ChannelIndicators)({
    marginLeft: -constants_1.theme.spacing[1],
    marginRight: constants_1.theme.spacing[1],
});
const TextColumn = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: constants_1.theme.spacing[0.5],
    userSelect: 'none',
    marginRight: 'auto',
});
const Header = styled_1.default.span({
    fontWeight: constants_1.theme.font.weight.medium,
    fontSize: 12,
});
const Subtitle = styled_1.default.span({
    fontSize: 10,
    opacity: 0.75,
});
const OnCallPadding = styled_1.default.div({
    paddingTop: constants_1.theme.spacing[1],
    paddingBottom: constants_1.theme.spacing[1],
    paddingLeft: constants_1.theme.spacing[1.5],
    paddingRight: constants_1.theme.spacing[1.5],
    width: '100%',
    boxSizing: 'border-box',
});
const AbsoluteBadge = (0, styled_1.default)(elements_1.Div)(({ background, color }) => ({
    background,
    color,
    borderRadius: constants_1.theme.border.radius.normal,
    position: 'absolute',
    top: `-${constants_1.theme.border.width.thin}px`,
    right: `-${constants_1.theme.border.width.thin}px`,
    fontWeight: constants_1.theme.font.weight.book,
    padding: `${constants_1.theme.spacing['0.5']}px ${constants_1.theme.spacing['1.5']}px`,
    lineHeight: 1,
    select: 'none',
    span: {
        display: 'block',
        fontSize: constants_1.theme.font.size['6.5'],
        letterSpacing: -2,
    },
}));
const NewShift = (props) => {
    const t = (0, translate_1.useTranslations)();
    const style = useShiftDesign(props.status, props.shift);
    const PopoverContent = props.popoverContent;
    const clickable = !!props.onClick || !!PopoverContent;
    const isBooked = props.status === 'BOOKED';
    const times = `${props.shift.startTime}-${props.shift.endTime}`;
    const { zoom, availableChannels } = (0, useSchedule_1.useSchedule)();
    const { isSelected, toggleSelected, enableSelectShifts } = (0, useSchedule_1.useSelectedShifts)(props.shiftIds);
    const isMonth = zoom === 'month';
    const position = isMonth ? 'stretch' : (props.position ?? 'center');
    // const header = <Header>{isBooked ? times : style.label}</Header>
    const header = (0, jsx_runtime_1.jsx)(Header, { children: times });
    // const subtitle = (!isBooked && times) || props.unitName
    const subtitle = style.label || props.unitName;
    const channelIndicators = props.status === 'VACANT' ? ((0, jsx_runtime_1.jsx)(StyledChannelIndicators, { available: availableChannels, used: {
            isPublished: props.isPublished,
            isRequested: false,
            isTendered: props.isTendered,
        } })) : null;
    const urgentLabel = ((0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, { size: "sm", styles: WARNING_CSS, color: constants_1.Color.LIGHTER_RED, backgroundColor: constants_1.Color.TRANSPARENT, design: "solid", iconName: "ExclamationIcon", tooltipIntent: "warning", text: t.shifts.urgent() }));
    const absentLabel = ((0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, { size: "sm", styles: WARNING_CSS, color: constants_1.Color.WHITE, backgroundColor: constants_1.Color.TRANSPARENT, design: "solid", iconName: "PlusCircleIcon", tooltipIntent: "warning", text: t.shifts.absent() }));
    const interestedBadge = ((0, jsx_runtime_1.jsx)(AbsoluteBadge, { background: constants_1.Color.BLUE, color: constants_1.Color.WHITE, children: (0, jsx_runtime_1.jsxs)("span", { children: [props.interestedCandidates, " / ", props.shiftIds.length] }) }));
    const countBadge = props.shiftIds.length > 1 ? ((0, jsx_runtime_1.jsx)(AbsoluteBadge, { background: constants_1.Color.LIGHTEST_BLUE, color: constants_1.Color.BLUE, children: (0, jsx_runtime_1.jsxs)("span", { children: ["\u00D7 ", props.shiftIds.length] }) })) : null;
    const iconAndCheckbox = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { className: "icon", size: "sm", name: style.icon, color: style.iconColor }), (0, jsx_runtime_1.jsx)(elements_1.Div, { className: "checkbox", onClick: (e) => e.stopPropagation(), children: props.onDelete ? ((0, jsx_runtime_1.jsx)(elements_1.Icon, { size: "sm", name: "TrashIcon", color: constants_1.Color.RED, onClick: () => props.onDelete?.() })) : ((0, jsx_runtime_1.jsx)(elements_1.Checkbox, { size: "sm", checked: isSelected, onChange: toggleSelected })) })] }));
    const content = isMonth ? ((0, jsx_runtime_1.jsx)(MonthContent, { children: iconAndCheckbox })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Content, { children: [channelIndicators, (0, jsx_runtime_1.jsxs)(TextColumn, { children: [isBooked && props.isAcknowledged ? ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 0.5, children: [header, (0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, { size: "xs", iconName: "CheckIcon", color: style.color, backgroundColor: constants_1.Color.TRANSPARENT, text: t.ui.shift_acknowledged_by_candidate() })] })) : (header), subtitle && (0, jsx_runtime_1.jsx)(Subtitle, { children: subtitle })] }), iconAndCheckbox] }), props.shift.onCallTime && ((0, jsx_runtime_1.jsx)(OnCallPadding, { children: (0, jsx_runtime_1.jsx)(ShiftCrossSection_1.ShiftCrossSection, { size: "sm", shiftHours: style.shiftHours, ...props.shift }) })), props.isUrgent && urgentLabel, props.isAbsent && absentLabel, props.interestedCandidates ? interestedBadge : countBadge] }));
    const shift = ((0, jsx_runtime_1.jsx)(Card, { ...style, position: position, as: clickable ? 'button' : 'div', onClick: props.onClick ? () => props.onClick(props.shiftIds) : undefined, hasOnCall: !isMonth && !!props.shift.onCallTime, hoverable: clickable, selectable: !!props.onDelete || (!props.unselectable && enableSelectShifts), selected: isSelected, isAbsent: props.isAbsent, isUrgent: props.isUrgent, isAtOtherUnit: props.isAtOtherUnit, zoom: zoom, children: content }));
    const withTooltip = props.error ? ((0, jsx_runtime_1.jsxs)(RelativeWrapper, { position: position, children: [shift, props.error] })) : (shift);
    if (!PopoverContent)
        return withTooltip;
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, { children: [(0, jsx_runtime_1.jsx)(Popover.Trigger, { asChild: true, children: withTooltip }), (0, jsx_runtime_1.jsx)(PopoverContentWrapper, { sideOffset: 4, align: "start", side: "right", onOpenAutoFocus: (event) => event.preventDefault(), children: (0, jsx_runtime_1.jsx)(PopoverContent, { shiftId: props.shiftIds }) })] }));
};
exports.NewShift = NewShift;
